import React from 'react'
import MaterialSymbol from '../material-symbol'

const Search = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="search" {...props} />
))

Search.displayName = 'Search'

export default Search
